import React, {useState, useEffect} from 'react';
import {Title} from '../common/component_common.js';
import {getApiSystemVersion, getApiSystemStatus, getApiSystemLicense} from '../common/fetch_api/api_common.js';
import '../common/css/control_info.css';

const PageControlInfo = () => {

    const [versionData, setVersionData] = useState(null);
    const [statusData, setStatusData] = useState(null);
    const [statusUpdate, setStatusUpdate] = useState(false);
    
    const [statusView, setStatusView] = useState({freeSpace: '', diskUsage: ''});
    const [licenseData, setLicenseData] = useState(null);

    useEffect( () => {
        Promise.resolve( getApiSystemVersion() )
        .then( data => {
            // console.log('getApiSystemVersion', data);
            setVersionData(data);
        });

        Promise.resolve( getApiSystemStatus() )
        .then( data => {
            // console.log('getApiSystemStatus', data);
            let pre = JSON.stringify(statusData);
            let cur = JSON.stringify(data);

            // console.log('pre', pre);
            // console.log('cur', cur);
            
            if( pre !== cur )
            {
                setStatusData(data);
                setStatusUpdate(!statusUpdate);
            }
        });

        Promise.resolve( getApiSystemLicense() )
        .then( data => {
            setLicenseData(data);
        });

    }, []);

    useEffect( () => {

        if(!statusData) return;

        let free = `${(parseFloat(statusData.systemStats.disk[0].free) / 1024).toFixed(2)} GB`;
        let usage = `${parseInt(statusData.systemStats.disk[0].usage)}% (${(parseFloat(statusData.systemStats.disk[0].used) / 1024).toFixed(2)} GB)`;

        setStatusView({freeSpace: free, diskUsage: usage});

    }, [statusUpdate]);

    return (
        <>
            <Title title='Info'></Title>
            <div className="section control-info-area">
                <div className="version-area">
                    <div className="section-title mt-3">Version</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">System</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={versionData?versionData.server:''} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Prometheus</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={versionData?versionData.prometheus:''} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">InfluxDB</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={versionData?versionData.influxDb:''} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">PostgreSQL</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={versionData?versionData.postgreSql:''} readOnly/>
                        </div>
                    </div>
                </div>
                <div className="control-info-system-area">
                    <div className="section-title mt-3">System</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Free space</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={statusView.freeSpace} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Disk usage</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={statusView.diskUsage} readOnly/>
                        </div>
                    </div>
                </div>
                <div className="control-info-license-area">
                    <div className="section-title mt-3">License</div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Fingerprint</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={licenseData?licenseData.fingerprint:''} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 label-box">Activation Status</div>
                        <div className="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-8 col-8 ps-1">
                            <input className="form-control input-box" type="text" value={licenseData?licenseData.activationStatus:''} readOnly/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PageControlInfo;